// Show/hide an action dropdown, and disable all buttons in it to avoid hotkey submission.
function toggleBulkActionMenu(menu: HTMLElement | null, enabled: boolean) {
  if (!menu) return
  menu.hidden = !enabled

  for (const button of menu.querySelectorAll<HTMLButtonElement>('button')) {
    button.disabled = !enabled
  }
}

// Toggle which `mark as...` dropdown is visible based on the current mode.
export function toggleBulkActionMenus({markSelected, markAll}: Options) {
  toggleSelectAll({markSelected, markAll})

  toggleBulkActionMenu(document.querySelector('.js-notifications-mark-selected-actions'), markSelected)
  toggleBulkActionMenu(document.querySelector('.js-notifications-mark-all-actions'), markAll)
}

// Toggle which "select ..." text is visible based on the current mode.
function toggleSelectAll({markSelected, markAll}: Options) {
  const selectedText = document.querySelector<HTMLElement>('.js-select-all-text')
  // Blank slate without toolbar.
  if (!selectedText) return
  const selectedTextWithCount = document.querySelector<HTMLElement>('.js-count-selected-text')!
  const selectedTextWithAllCount = document.querySelector<HTMLElement>('.js-all-count-selected-text')!

  selectedText.hidden = markSelected || markAll
  selectedTextWithCount.hidden = !markSelected
  selectedTextWithAllCount.hidden = !markAll
}

type Options = {markSelected: boolean; markAll: boolean}

// Add a hidden input to form element and return the input.
function addHiddenInputToForm(form: HTMLFormElement, name: string, value: string): HTMLInputElement {
  const input = document.createElement('input')
  input.setAttribute('type', 'hidden')
  input.setAttribute('name', name)
  input.setAttribute('value', value)
  return form.appendChild(input)
}

export function updateSelectedNotificationsInBulkActionForms() {
  const container = document.querySelector<HTMLElement>('.js-notifications-container .js-check-all-container')!

  // Add selected notifications to bulk action forms as hidden inputs
  for (const form of container.querySelectorAll<HTMLFormElement>(
    '.js-notifications-mark-selected-actions .js-notification-bulk-action form',
  )) {
    addCheckedNotificationsToForm(form)
  }

  // Show/hide the bulk action menu depending on whether there is 1+ selected
  if (getCheckedElements().length === 0) {
    toggleBulkActionMenus({markSelected: false, markAll: false})
  } else {
    toggleBulkActionMenus({markSelected: true, markAll: false})
  }
}

// Add the checked notification items to the bulk action form.
function addCheckedNotificationsToForm(form: HTMLFormElement) {
  // Remove any previous notification id input elements from the form
  for (const input of form.querySelectorAll('[data-bulk-notification]')) {
    input.remove()
  }

  // Add all checked notification ids as input elements to the form
  for (const checked of getCheckedElements()) {
    const input = addHiddenInputToForm(form, checked.name, checked.value)
    input.setAttribute('data-bulk-notification', '')
  }
}

export function getCheckedElements() {
  return document.querySelectorAll<HTMLInputElement>(
    '.js-notifications-container .js-check-all-container [data-check-all-item]:checked',
  )
}
